import { omitBy } from 'lodash'
import queryString from 'query-string'
import { useCallback } from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router'

export function useMatchParams<T = Record<string, string>>() {
  const { params } = useRouteMatch<T>()
  return params
}

export function useQueryParams<T extends Record<string, any>>() {
  const { search } = useLocation()
  return queryString.parse(search) as T
}

export function useQueryPageParam(): number {
  const { page } = useQueryParams<{ page: string }>()
  return Number(page) || 0
}

export function useQueryUtils() {
  const history = useHistory()

  const replaceQueryParams = useCallback(
    (query) => {
      const { location } = history
      const currentQuery = queryString.parse(location.search)
      const filteredQuery = omitBy({ ...currentQuery, ...query }, (value) => !value)
      const newQuery = queryString.stringify(filteredQuery)
      history.replace(`${location.pathname}?${newQuery}`)
    },
    [history]
  )

  const replaceQueryPageParam = useCallback((page) => replaceQueryParams({ page }), [replaceQueryParams])

  const replaceQuery = useCallback(
    (query) => {
      const { location } = history
      const newQuery = queryString.stringify(query)
      history.replace(`${location.pathname}?${newQuery}`)
    },
    [history]
  )

  return {
    replaceQueryPageParam,
    replaceQueryParams,
    replaceQuery,
  }
}
